import { render } from "./NormRow.vue?vue&type=template&id=60ad1ed1&scoped=true"
import script from "./NormRow.vue?vue&type=script&lang=js"
export * from "./NormRow.vue?vue&type=script&lang=js"

import "./NormRow.vue?vue&type=style&index=0&id=60ad1ed1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ad1ed1"]])

export default __exports__